export default __webpack_public_path__ + "static/media/hint-error.8f572ac4.svg";